export const taxTypes = [
  {
    key: '01',
    label: 'Sales Tax',
  },
  {
    key: '02',
    label: 'Service Tax',
  },
  {
    key: '03',
    label: 'Tourism Tax',
  },
  {
    key: '04',
    label: 'High-Value Goods Tax',
  },
  {
    key: '05',
    label: 'Sales Tax on Low Value Goods',
  },
  {
    key: '06',
    label: 'Not Applicable',
  },
  {
    key: 'E',
    label: 'Tax Exemption',
  },
]
